import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { constantsData, statusTypesData } from "@/data";
import { addPermissionMutation } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useAddPermission = (setAddedPermissions, setRemovedPermissions, refetch) => {
    const [addPermissionAction, { loading }] = useMutation(addPermissionMutation);

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const addPermission = async ({ permissions, roleId }) => {
        try {
            await addPermissionAction({
                onCompleted: () => {
                    setAddedPermissions([]);

                    setRemovedPermissions([]);

                    refetch();

                    dispatch(
                        openAlert(
                            t("messages.editMsgs.success", { entity: t("permissions.name") }),
                            statusTypesData.success,
                        ),
                    );
                },
                variables: {
                    addedPermission: {
                        id: roleId,
                        permissions: permissions.map((permission) => ({ permission_name: permission })),
                    },
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        }
    };

    return {
        addPermission,
        loading,
    };
};

export default useAddPermission;
